import { callApi } from './service'

export const contactUsService = {
    sendContactMessage
};  

async function sendContactMessage(params) {
    return callApi('/Site/PrideMxContactUs', 'POST', params, {"SkipValidationToken" : true}).then((result) => {
        if (result.responseCode === '00') {
            return result.responseMessage;
        } else {
            return null;
        }
    });
}




